import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_NAME = process.env.REACT_APP_USER_NAME;
const PASSWORD = process.env.REACT_APP_PASSWORD;

const initialState = {
    isLoading: false,
    data: [],
    isError: false,
    
}

// Generates pending, fulfiled, rejected action types
export const fetchIssuers = createAsyncThunk('fetchIssuers', async () => {
    const response = await fetch(`${API_BASE_URL}/issuer`, {
        method: 'GET',
        headers: { 'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`) }
    });
    return response.json();
});

export const deleteIssuer = createAsyncThunk('deleteIssuer', async ({id}, {dispatch}) => {
    const details = {
        'issuer_id': id,
    };

    let formBody = [];
    for (let property in details) {
    let encodedKey = encodeURIComponent(property);
    let encodedValue = encodeURIComponent(details[property]);
    formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");

    
    const response = await fetch(`${API_BASE_URL}/issuer/delete`, {
        method: 'POST',
        headers: { 
            'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: formBody
    });
    dispatch(fetchIssuers());
    return response.json(); 
});

const issuerSlice = createSlice({
    name: 'issuer',
    initialState,
    extraReducers: (builder) => {
        builder.addCase(fetchIssuers.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchIssuers.fulfilled, (state, action) => {
            state.isLoading = false;
            if(action.payload.data) {
                state.data = action.payload.data;
            } else {
                state.isError = true;
            }
        });
        builder.addCase(fetchIssuers.rejected, (state, action) => {
            state.isError = true;
            state.isLoading = false;
        })
    }
});

export default issuerSlice;